export const enum PartyType {
    unknown,
    firstParty,
    thirdParty,
}
